/**
 * Application Javascript Module
 */
import "babel-polyfill";
import ApiManager from "./app/ApiManager";
let api;

const apiFactory = () => {
  if (api) {
    return api;
  }
  const isStaging =
    window.location.href.includes("staging.solarschools.net") && false;
  api = new ApiManager(
    `https://api.${isStaging ? "staging." : ""}solarschools.net/v1`,
    typeof user !== "undefined" ? user : null,
    typeof refreshUserUri !== "undefined" ? refreshUserUri : null
  );
  return api;
};

/**
 * Force element scrolling links
 */
window.onload = function() {
  if (window.location.hash) {
    var elmnt = document.getElementById(window.location.hash.substring(1));
    elmnt.scrollIntoView(true);
  }
};

// import the Application JS Modules

//mega menu
import megaMenu from "./app/megamenu.js";
megaMenu();

// School Search
import schoolSearch from "./app/schoolSearch.js";
schoolSearch();

// site Search
import siteSearch from "./app/siteSearch.js";
siteSearch();

// About menu
import About from "./app/about.js";
About();

// learning resources
import learningResources from "./app/learningResources.js";
learningResources();

// Curriculum Blocks
import CurriculumBlock from "./app/curriculumBlock.js";
CurriculumBlock();

// Water Graph
import waterGraph from "./app/waterGraph.js";
waterGraph();

// School Profile
import schoolProfile from "./app/schoolProfile.js";
if (document.getElementById("school-profile")) {
  schoolProfile(apiFactory());
}

import comparisonBars from "./app/comparisonBars.js";
if (document.getElementById("comparison-bars")) {
  comparisonBars(apiFactory());
}

// Teachers Toolki
import teachersToolkit from "./app/teachersToolkit.js";
if (document.getElementById("teachers-toolkit")) {
  teachersToolkit(apiFactory());
}

import teachersToolkitGuide from "./app/teachersToolkitGuide.js";
if (document.getElementById("teachers-toolkit-guide")) {
  teachersToolkitGuide(apiFactory());
}

import teachersToolkitTraining from "./app/teachersToolkitTraining.js";
if (document.getElementById("teachers-toolkit-training")) {
  teachersToolkitTraining(apiFactory());
}

// School Directory
import schoolsList from "./app/schoolsList.js";
if (document.querySelector("[data-school-directory]")) {
  schoolsList(apiFactory());
}

// School Map
import schoolsMap from "./app/schoolMap";
if (document.querySelector("[data-school-map]")) {
  schoolsMap(apiFactory());
}

// Duration Slider
import DurationSlider from "./app/DurationSlider";
DurationSlider();

// Plan Buttons
import PlanButtons from "./app/PlanButtons";
PlanButtons();

// PricingList
import PricingList from "./app/pricingList.js";
PricingList();



// WEBPACK FOOTER //
// ./resources/assets/js/app.js